module.exports = "<div class=\"switcher\">\r\n  <p class=\"label-switcher\">{{ title }}</p>\r\n  <div class=\"container-switcher\">\r\n      <input type=\"checkbox\" [id]=\"element\" [(ngModel)]=\"switcher\" [checked]=\"switcher\" (change)=\"change()\" [disabled]=\"disabled\" data-switch=\"primary\">\r\n      <label [for]=\"element\" data-in-label=\"Sí\" data-off-label=\"No\"></label>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/switcher/switcher.component.html
// module id = ./src/app/components/tools/switcher/switcher.component.html
// module chunks = main